import React from 'react';
import { useIntl } from 'react-intl';

import { CaptionType } from '../../../models/caption/Caption';
import { FormTitle as FormTitleType } from '../../../services/form/FormTitle';
import { getCaptionText } from '../Caption';

interface Props {
  title: FormTitleType;
}

const FormTitle = ({ title }: Props): React.JSX.Element => {
  const { formatMessage } = useIntl();

  return typeof title === 'string' ? (
    <span>{title}</span>
  ) : title.type === CaptionType.BUILT_IN ? (
    <span>{getCaptionText(title, formatMessage)}</span>
  ) : (
    <span>
      {Object.keys(title)[0]}:{' '}
      {getCaptionText(Object.values(title)[0], formatMessage)}
    </span>
  );
};

export default FormTitle;
